import {utilHelper} from '../../_helpers';

const relativeUrl = 'api/moduleUdn'

export const moduleUdnService = {
    search,
    add,
    remove
};

function search(max, offset, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search`, 'POST', { data: data, showAlert: false })
}

function remove(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/remove`, 'POST', { data: data });
}

function add(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/add`, 'POST', { data: data });
}
